<template>
  <div class="p-2">
    <h2 class="">Impressum</h2>

    <div class="ml-2 mt-2">
      <h2>Angaben gemäß §5 TMG</h2>
      <p>
        <span class="block">Philipp Hugenroth</span>
        <span class="block">Jupp-Müller Straße 5</span>
        <span class="block">52072 Aachen</span>
      </p>
      <p>
        E-Mail: philipp@hgnrth.de
      </p>
      <h2>
        Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
      </h2>
      <p>
        Philipp Hugenroth <br />
        Jupp-Müller Straße 5 <br />
        52072 Aachen
      </p>
    </div>

    <div class="w-full border-white border-b-2 mt-4 mb-4"></div>

    <div>
      <b>Verwendete Software:</b>
      <ul class="list-disc ml-8">
        <li>
          Vue.js mit Vue Router
        </li>
        <li>
          TailwindCSS
        </li>
        <li>
          Spotify API & Spotify Web Playback SDK
        </li>
        <li>
          Airtable API
        </li>
        <li>
          Vercel (ZEIT now)
        </li>
      </ul>
    </div>

    <div class="w-full border-white border-b-2 mt-4 mb-4"></div>

    <h3>Haftung für Inhalte</h3>
    <p>
      Die auf den Web-Seiten abrufbaren Beiträge dienen nur der allgemeinen
      Information und nicht der Beratung in konkreten Fällen. Wir sind bemüht,
      für die Richtigkeit und Aktualität aller auf der Website enthaltenen
      Informationen und Daten gemäß § 7 Abs.1 TMG zu sorgen. Für die
      Korrektheit, die Vollständigkeit, die Aktualität oder Qualität der
      bereitgestellten Informationen und Daten wird jedoch keine Gewähr nach § 8
      bis 10 TMG übernommen. Die Haftung für den Inhalt der abrufbaren
      Informationen wird ausgeschlossen, soweit es sich nicht um vorsätzliche
      oder grob fahrlässige Falschinformation handelt. Verpflichtungen zur
      Entfernung oder Sperrung der Nutzung von Informationen nach den
      allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
      Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
      Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
      Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
    </p>
    <h3>Haftung für Links</h3>
    <p>
      Wir sind für den Inhalt von Webseiten, die über einen Hyperlink erreicht
      werden, nicht verantwortlich. Für den Inhalt der verlinkten Seiten sind
      ausschließlich deren Betreiber verantwortlich. Wir machen uns die Inhalte
      dieser Internetseiten ausdrücklich nicht zu eigen und können deshalb für
      die inhaltliche Korrektheit, Vollständigkeit und Verfügbarkeit keine
      Gewähr leisten. Wir haben bei der erstmaligen Verknüpfung zwar den fremden
      Inhalt daraufhin überprüft, ob durch ihn eine mögliche zivilrechtliche
      oder strafrechtliche Verantwortlichkeit ausgelöst wird. Wir sind aber
      nicht dazu verpflichtet, die Inhalte, auf die wir unserem Angebot
      verweisen, ständig auf Veränderungen zu überprüfen, die eine
      Verantwortlichkeit neu begründen könnten. Erst wenn wir feststellen oder
      von anderen darauf hingewiesen werden, dass ein konkretes Angebot, zu dem
      wir einen Link bereitgestellt haben, eine zivil- oder strafrechtliche
      Verantwortlichkeit auslöst, werden wir den Verweis auf dieses Angebot
      aufheben, soweit uns dies technisch möglich und zumutbar ist.
    </p>
    <h3>Urheberrecht</h3>
    <p>
      Die durch den Betreiber dieser Seite erstellten Inhalte und Werke auf
      diesen Webseiten unterliegen dem deutschen Urheberrecht. Sämtliche
      Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung,
      Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
      des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen
      Autors bzw. Erstellers. Kopien von diesen Seiten sind nur für den privaten
      Bereich gestattet, nicht jedoch für kommerzielle Zwecke.
    </p>
    <h3>Datenschutz</h3>
    <p>
      Die Nutzung unserer Webseite ist in der Regel ohne Angabe
      personenbezogener Daten möglich. Soweit auf unseren Seiten
      personenbezogene Daten (beispielsweise Name, Anschrift oder
      E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf
      freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung
      nicht an Dritte weitergegeben.
    </p>
    <p>
      In Verbindung mit Ihrem Zugriff werden in unserem Server für Zwecke der
      Datensicherheit vorübergehend Daten gespeichert, die möglicherweise eine
      Identifizierung zulassen (zum Beispiel IP-Adresse, Datum, Uhrzeit und Name
      der angeforderten Datei). Eine Auswertung, mit Ausnahme für statistische
      Zwecke in anonymisierter Form, erfolgt nicht.
    </p>
    <p>
      Sollten Sie bei uns Informationsmaterialien bestellen, benötigen wir von
      Ihnen Name, E-Mail-Adresse sowie Angaben zur Lieferung und
      Rechnungsstellung. So können wir Ihre Bestellung bearbeiten und ausführen.
      Diese Daten werden für die Dauer der Auftragsabwicklung in elektronischer
      Form gespeichert. Eine weitergehende Nutzung personenbezogener Daten oder
      eine Weitergabe an Dritte erfolgt ohne Ihre ausdrückliche Einwilligung
      nicht.
    </p>
    <p>
      Mit der Bestellung willigen Sie in die genannte Verarbeitung Ihrer
      personenbezogenen Daten ein, soweit dies für den Zweck des Vertrages
      erforderlich ist. Sie können diese Einwilligung schriftlich oder per
      E-Mail uns gegenüber jederzeit mit Wirkung für die Zukunft widerrufen.
    </p>
    <h3>Datenschutzerklärung für die Nutzung von Google Analytics</h3>
    <p>
      Diese Website benutzt Google Analytics, einen Webanalysedienst der Google
      Inc. („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien,
      die auf Ihrem Computer gespeichert werden und die eine Analyse der
      Benutzung der Website durch Sie ermöglichen. Die durch den Cookie
      erzeugten Informationen über Ihre Benutzung dieser Website werden in der
      Regel an einen Server von Google in den USA übertragen und dort
      gespeichert.
    </p>
    <p>
      Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird
      Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der
      Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den
      Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die
      volle IP-Adresse an einen Server von Google in den USA übertragen und dort
      gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese
      Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um
      Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit
      der Websitenutzung und der Internetnutzung verbundene Dienstleistungen
      gegenüber dem Websitebetreiber zu erbringenDie im Rahmen von Google
      Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen
      Daten von Google zusammengeführt.
    </p>
    <p>
      Sie können die Speicherung der Cookies durch eine entsprechende
      Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch
      darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
      Funktionen dieser Website vollumfänglich werden nutzen können. Sie können
      darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
      Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google
      sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das
      unter dem folgenden Link verfügbare Browser-Plugin herunterladen und
      installieren http://tools.google.com/dlpage/gaoptout?hl=de.
    </p>
    Quelle:
    <a href="http://www.impressumvorlage.de/" target="_blank"
      >impressumvorlage.de</a
    >
    <h3 class="mt-4">
      Airtable API
    </h3>
    <p>
      <a href="https://airtable.com/privacy">Privacy Notice</a>
    </p>

    <h3 class="mt-4">
      Spotify
    </h3>
    <p>
      <a href="https://www.spotify.com/us/legal/privacy-policy/"
        >Privacy Notice</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "Impressum"
};
</script>
